/**
 * Action that resets the root state of our redux store.
 * It is mainly used while logging in and logging out to make sure
 * states aren't cached between users due to redux-persist
 */

import { RESET_ROOT_STATE } from './types';

export default () => ({ type: RESET_ROOT_STATE });
